<template>
  <div class="authorized-view">
    <!--操作栏-->
    <div class="handle_wrapper">
      <butn
        class="btn-wrapper"
        v-permission="'liveRoomRule:save'"
        btntype="primary"
        title="新增"
        @click.native="showAddModal"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'liveRoomRule:exportPhone'"
        btntype="primary"
        title="导出手机号"
        @click.native="exportPhone"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'liveRoomRule:export:unique'"
        btntype="primary"
        title="去重导出全部手机号"
        @click.native="exportUniquePhone"
      ></butn>
      <span class="tip_msg">通过授权范围开放的用户，无法同步至干部之家，进行指定用户直播弹窗提醒。</span>
    </div>
    <Table
      :data="tableData"
      row-key="uuid"
      @handleDetete="handleDetete"
      @handleEdit="handleEdit"
    />
    <!-- 新增/编辑 -->
    <AuthorizedModal
      :addDialog="addDialog"
      :liveRoomId="liveRoomId"
      @closeDialog="closeAddDialog"
      v-if="addDialog.flag"
    />
    <EditModal
      v-if="editInfo.show"
      :info="editInfo"
      @closeDialog="closeEditDialog"
    />
  </div>
</template>
<script>
import { getLiveRoomRuleList, deleteLiveRoomRule, exportliveRoomRulePhone, exportLiveRoomUniquePhone } from "@/api/resourceService"
import butn from "@/components/button/index";
import AuthorizedModal from "./authorizedModal";
import Table from "./table.js";
import EditModal from "./editModal.vue";
import { ioRead } from "@/utils/common.js";

export default {
  components: {
    butn,
    AuthorizedModal,
    Table,
    EditModal,
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      api: getLiveRoomRuleList,
      liveRoomId: "",
      tableData: [],
      dataname: {},
      addDialog: {
        flag: false,
      },
      importDialog: { show: false },
      checkArray: [],
      editInfo: { show: false },
      allUsers: [],
    };
  },
  computed: {
  },
  created() {
    //加载列表
    this.liveRoomId = this.$route.query.liveRoomId;
    this.searchHandle();
  },
  methods: {
    // 导出手机号
    exportPhone() {
      exportliveRoomRulePhone({
        ...this.dataname,
        liveRoomId: this.liveRoomId,
      }).then((response) => ioRead(response));
    },

     // 去重导出全部手机号
     exportUniquePhone() {
      exportLiveRoomUniquePhone({
        liveRoomId: this.liveRoomId,
      }).then((response) => ioRead(response));
    },
    // 获取列表数据
    searchHandle() {
      getLiveRoomRuleList({ liveRoomId: this.liveRoomId }).then((res) => {
        if (res && res.code == 0) {
          this.tableData = res.data;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    addSucceed() {
      this.showAddUserDialog.flag = false;
      this.searchHandle();
    },
    async confirmWay(msg) {
      const flag = await this.$confirm(msg, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      return flag !== "confirm";
    },
    // 单个删除
    async handleDetete(row) {
      if (await this.confirmWay("确认删除该授权范围吗？")) return;
      deleteLiveRoomRule({ uuids: [row.uuid] }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.searchHandle();
      });
    },
    /**
     * 编辑
     */
    handleEdit(row) {
      this.editInfo = {
        show: true,
        liveRoomId: this.liveRoomId,
        uuid: row.uuid
      };
    },
    // 新增授权范围
    showAddModal() {
      this.addDialog.flag = true;
    },
    // 关闭授权窗口
    closeAddDialog(flag) {
      this.addDialog.flag = false;
      if (flag) {
        this.searchHandle();
      }
    },
    closeEditDialog(flag) {
      this.editInfo.show = false;
      if (flag) {
        this.searchHandle();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.authorized-view {
  margin-top: 15px;
}
.search-wrapper {
  float: right;
}
.btn-wrapper {
  margin-left: 0px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.content-top {
  padding-bottom: 20px;
  border-bottom: 1px solid #ececec;
  margin-bottom: 20px;
}
.tip_msg {
  font-size: 1rem;
}
</style>
